import React from 'react';
import { Box, Grid, Typography, Paper, Container, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { isKranawetterPortal } from '../utils/portalHost';

function AuthLayout({ children }) {
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));
    const onPortal = isKranawetterPortal();
    const backHref = onPortal ? 'https://www.kranawettertransport.com' : 'https://www.hammerlanetech.com';
    const backLabel = onPortal ? 'Back to kranawettertransport.com' : 'Back to hammerlanetech.com';

    return (
        <Box
            sx={{
                height: '100vh',
                display: 'flex',
                backgroundColor: theme.palette.grey[100],
                py: { xs: 2, md: 0 },
                overflow: 'hidden'
            }}
        >
            <Container maxWidth="lg" sx={{ my: 'auto' }}>
                <Grid container spacing={1} alignItems="center" justifyContent="center">
                    {/* Product Information Section - Only visible on large screens */}
                    {isLargeScreen && (
                        <Grid item xs={12} md={6} lg={5} sx={{ display: { xs: 'none', md: 'block' } }}>
                            <Box
                                sx={{
                                    p: { md: 2, lg: 3 },
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center'
                                }}
                            >
                                <Box 
                                    component="img"
                                    src="/hammer.png"
                                    alt="Kranawetter Driver Portal Logo"
                                    sx={{ 
                                        width: { md: 480, lg: 640 },
                                        height: 'auto',
                                        maxWidth: '100%',
                                        mb: 2,
                                        alignSelf: 'flex-start',
                                        objectFit: 'contain'
                                    }}
                                />
                                
                                <Typography variant="h5" gutterBottom color="primary" sx={{ fontWeight: 'bold', mb: 1 }}>
                                    Operations Command Center
                                </Typography>
                                
                                <Typography variant="subtitle1" gutterBottom sx={{ mb: 1, fontWeight: 'medium', color: 'text.secondary' }}>
                                    Comprehensive fleet operations management with real-time monitoring and secure access control
                                </Typography>
                                
                                <Grid container spacing={1} sx={{ mt: 1 }}>
                                    <Grid item xs={12}>
                                        <Paper elevation={0} sx={{ p: 1.5, bgcolor: '#1B5E20', borderRadius: 2 }}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: 'white' }}>
                                                Compliance & Document Control
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: 'white', fontSize: '0.8rem' }}>
                                                DOT documents, expirations, permits, and automated alerts in one place.
                                            </Typography>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Paper elevation={0} sx={{ p: 1.5, bgcolor: '#0D47A1', borderRadius: 2 }}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: 'white' }}>
                                                Equipment & Fleet Status
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: 'white', fontSize: '0.8rem' }}>
                                                Truck inventory, inspection data, and maintenance readiness at a glance.
                                            </Typography>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Paper elevation={0} sx={{ p: 1.5, bgcolor: '#B71C1C', borderRadius: 2 }}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: 'white' }}>
                                                Sites & Access Control
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: 'white', fontSize: '0.8rem' }}>
                                                Drop lots, encrypted gate codes, and customer locations with role-based access.
                                            </Typography>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Paper elevation={0} sx={{ p: 1.5, bgcolor: '#4A148C', borderRadius: 2 }}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: 'white' }}>
                                                Customers & Team
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: 'white', fontSize: '0.8rem' }}>
                                                Customer accounts, driver engagement, and operational dashboards.
                                            </Typography>
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    )}
                    
                    {/* Auth Component (Login, Reset Password, etc.) */}
                    <Grid item xs={12} md={6} lg={7}>
                        {children}
                        <Box sx={{ mt: 2, textAlign: 'center' }}>
                            <Typography variant="body2" color="text.secondary">
                                <a href={backHref} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>
                                    {backLabel}
                                </a>
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}

export default AuthLayout; 